export const inboxWords = {
  yourReply: "Your reply",
  replyDraft: "Reply draft",
  readyToReply: "Ready to reply",
  sendReply: "Send reply",
  sendPreview: "Send preview",
  whenYouSend: "When you send",
  sendToOtherPerson: "Send this reply to the other person.",
  privateToTwo: "Private to the two of you.",
  writeReply: "Write a reply before sending.",
  conversationUnavailable: "This conversation can no longer be read. No reply can be sent.",
  reconnectToReply: "Reconnect this messaging channel before replying.",
  replySent: "Reply sent.",
  legacyNotSent: "This message was not sent. Review it before sending a new message.",
  replyNotSent: "Reply not sent",
  sendUnknown: "The send is not confirmed. Check its status before sending again.",
  checkStatus: "Check status",
  checkOnly: "Read the result of the original send without sending again.",
  stale: "Could not refresh. A later change is not shown.",
  newMessage: "New message",
  messageDraft: "Message draft",
  nothingStarted: "Nothing started",
  messageUnknown: "Message not confirmed",
  messageConfirmed: "Message confirmed",
  messageAdded: "Message added to the conversation.",
  messageNotSent: "Message not sent",
  startPrivate: "Start a private message about one of your courses.",
  startWith: (name: string) => `Start a private conversation with ${name}.`,
  personUnavailable: (name: string) => `${name} is not available for messages in this course. No one else was picked.`,
  channelNotReady: "This messaging channel is not connected. Read the connections before sending.",
  chooseCourse: "Choose a course first.",
  choosePerson: "Choose who this message is for.",
  sessionUnavailable: "This session is unavailable. Choose a session in this course or the whole course.",
  addSubject: "Add a subject for this email.",
  writeMessage: "Write the message first.",
  contextFailed: "Could not read your messaging connections and course recipients.",
  to: "To",
  personChosen: "Person chosen",
  chooseRecipient: "No person chosen",
  sendAs: "Send as",
  course: "Course",
  chooseCourseOption: "Choose a course",
  person: "Person",
  choosePersonOption: "Choose a person",
  recipientUnavailable: "Selected recipient unavailable",
  unavailableSuffix: " - messaging unavailable",
  optionalSession: "Session (optional)",
  wholeCourse: "Whole course",
  message: "Message",
  messageWritten: "Message written",
  notWritten: "Not written",
  subject: "Subject",
  optionalTopic: "Topic (optional)",
  sendMessage: "Send message",
  privatePreview: "Private to the two of you. Local preview only; no email or Google Chat message is sent.",
  messagingConnections: "Messaging connections",
  readConnections: "Read your messaging connection records.",
  gmail: "Gmail",
  googleChat: "Google Chat",
  localPreview: "local preview",
  connected: "connected",
  reconnectNeeded: "reconnect needed",
  notSetUp: "not set up",
  reconnectNewTab: (provider: string) => `Reconnect ${provider} (new tab)`,
  and: " and ",
  needsReconnect: (providers: string) => `${providers} needs reconnecting. Messages on that channel cannot be sent yet.`,
  previewConnections: "Local messaging preview is ready.",
  allConnected: "Connected.",
  connectionsNotSetUp: "Email and chat are not set up yet.",
  askForReconnect: (providers: string) => `Ask your administrator to configure ${providers} reconnection.`,
  writeAnotherMessage: "Write another message",
  newAnnouncement: "New notice",
  prepareNotice: "Post a notice Academy-wide or to one of your courses.",
  prepareCourseNotice: "Post a notice to this course.",
  audience: "Audience",
  selectedAudience: "Selected audience",
  selectedAudienceUnavailable: "Selected audience unavailable",
  chooseAudience: "Choose an audience you can post to.",
  chooseAudienceOption: "Choose an audience",
  audienceChosen: "Audience chosen",
  noAudience: "No audience chosen",
  audienceCountUnread: "Read the email audience before posting with email.",
  emailCountUnread: "Email on post - audience has not been read.",
  emailAudience: (count:number,audience:string)=>`Email on post: ${count} ${count===1?"recipient":"recipients"} in ${audience}.`,
  postTo: (audience:string)=>`Post this notice to ${audience}.`,
  category: "Category",
  markUrgent: "Mark urgent",
  title: "Title",
  titleWritten: "Title written",
  noTitle: "No title written",
  addNoticeTitle: "Add a title before posting.",
  writeNotice: "Write the notice before posting.",
  post: "Post notice",
  whenPost: "When you post",
  partlyDone: "Partly done",
  postNotConfirmed: "Post not confirmed",
  noticePosted: "Notice posted.",
  notPosted: "Notice not posted",
  postNotCommitted: "This notice was not posted. Review it before posting again.",
  postUnknown: "The post is not confirmed. Check the original post before posting again.",
  audiencesFailed: "Could not read the audiences you can post to.",
  noticeDraft: "Notice draft",
  notStarted: "Not started",
  emailRetry: "Retry email",
  emailRetryOnly: "Retry only failed or unattempted email chunks, without posting the notice again.",
  emailNotConfirmed: (count:number)=>count?`Email is not confirmed for ${count} ${count===1?"recipient":"recipients"}. Check before any further send.`:"Email is not confirmed. Check before any further send.",
  emailCheckOnly: "Read the original post and email status without sending again.",
  postAnother: "Post another notice",
  notices: "Notices",
  allNotices: "All notices",
  unreadNotices: "Unread notices",
  allRead: "All read",
  notice: "notice",
  noticesUnit: "notices",
  readNotices: "Read your institution and course notices.",
  noticesFailed: "Could not read notices. They come back with this read.",
  privateMessages: "Private messages",
  readCoursePeople: "Choose a person for a private course message.",
  noMessagePeople: "No people are available for messages in this course.",
  peopleFailed: "Could not read who can be messaged in this course.",
  openInbox: "Open Inbox",
  teacher: "Teacher",
  student: "Student",
  messagePerson: "Message",
  noNotices: "No notices yet.",
  institutionAndCourses: "Academy-wide and course notices addressed to you.",
  courseAndInstitution: "This course's notices and Academy-wide notices.",
  selectedCourse: "Selected course",
  findNotice: "Find a notice",
  allCourses: "All courses",
  academyWide: "Academy-wide",
  urgent: "Urgent",
  urgentUnread: "Urgent, unread",
  conversationReadFailed: "Read status could not be saved. The conversation remains available.",
  markReadFailed: "Read status could not be saved. The notice remains available.",
  tryMarkRead: "Try marking read again",
  categories: {academic:"Academic",financial:"Financial",intensive:"Intensive",urgent:"Urgent",general:"General"},
  selectionUnavailable: "This address contains conflicting or unavailable selections, so nothing was opened.",
  returnInbox: "Return to Inbox",
  inbox: "Inbox",
  channel: "Channel",
  allChannels: "All channels",
  conversationsFailed: "Could not read conversations. Your saved conversations come back with this read.",
  connectionsFailed: "Could not read messaging connections. No channel is known to be connected until this reads.",
  conversations: "Conversations",
  latestFirst: "Latest first",
  findConversation: "Find a conversation by subject or person.",
  search: "Search by subject or person",
  noConversations: "No conversations yet.",
  startMessage: "Start a message from one of your courses.",
  unread: "Unread",
  read: "Read",
  replyUnknown: "Reply not confirmed",
  messages: "Messages",
  noConfirmedMessages: "No confirmed messages have been read yet.",
  you: "You",
  participant: "Participant",
  notSent: "Not yet sent",
  open: "Open",
  email: "Email",
  chat: "Chat",
} as const;

export function messageTime(value: string | null, now = new Date()): string {
  if (!value) return inboxWords.notSent;
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return inboxWords.notSent;
  const sameDay = at.toDateString() === now.toDateString();
  const day = sameDay ? "Today" : new Intl.DateTimeFormat("en-US", {
    weekday: "short", month: "short", day: "numeric",
    ...(at.getFullYear() === now.getFullYear() ? {} : { year: "numeric" }),
  }).format(at);
  return `${day}, ${new Intl.DateTimeFormat("en-US", {hour:"numeric",minute:"2-digit"}).format(at)}`;
}
